import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';

export interface AcademicYearFilterDatamodel {
  visible: boolean;
  onHide: () => any;
  academicYearDefaultValue: number;
  onFinish: (academicYear: number) => any;
  title: string;
}

export const AcademicYearFilter: React.FC<AcademicYearFilterDatamodel> = ({
  visible,
  onHide,
  academicYearDefaultValue,
  onFinish,
  title,
}) => {
  const [academicYear, setAcademicYear] = useState<number>(
    academicYearDefaultValue,
  );

  // Generate academic year options (2023-2027)
  const academicYearOptions = Array.from({ length: 5 }, (_, i) => {
    const year = 2023 + i;
    return {
      label: `${(year + 1).toString()} - ${year.toString()}`,
      value: year,
    };
  });

  // Update local state when default value changes
  useEffect(() => {
    setAcademicYear(academicYearDefaultValue);
  }, [academicYearDefaultValue]);

  const handleApply = () => {
    onFinish(academicYear);
    onHide();
  };

  return (
    <Dialog
      header={title}
      visible={visible}
      style={{ width: '350px' }}
      onHide={() => onHide()}
      modal
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <div>
          <label
            style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: 'bold',
            }}
          >
            שנה אקדמית:
          </label>
          <Dropdown
            value={academicYear}
            options={academicYearOptions}
            onChange={(e) => setAcademicYear(e.value)}
            style={{ width: '100%' }}
            placeholder="בחר שנה אקדמית"
          />
        </div>

        {/* Action Buttons */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '8px',
            marginTop: '16px',
          }}
        >
          <Button label="ביטול" outlined onClick={() => onHide()} />
          <Button label="החל" onClick={handleApply} />
        </div>
      </div>
    </Dialog>
  );
};
